export function flattenMenus(menus) {
  return menus.reduce((prev, {children = [], ...cur}) => {
    if (children?.length > 0) {
      return prev.concat(cur).concat(flattenMenus(children));
    }
    return prev.concat(cur);
  }, []);
}

/**
 * 将菜单转化为下面的形式
 * [code]: [name]
 * 1: "自动采集"
 * 2: "自动采集/采集任务"
 * 3: "自动采集/采集任务/子页面名称"
 */
export function formatBreadcrumb(menus) {
  function recursive(arr, parentName = '') {
    return Array.isArray(arr) && arr.length > 0
      ? arr.reduce((pre, cur) => {
          const name = cur.name ?? '';
          const code = cur.code ?? '';
          const children = cur.children ?? [];

          const curName = `${parentName ? `${parentName}/` : ''}${name}`;
          const curPathTitleObj = {
            [code]: curName,
          };

          pre = {
            ...pre,
            ...curPathTitleObj,
            ...(children.length > 0 ? recursive(children, curName) : {}),
          };
          return pre;
        }, {})
      : {};
  }
  const breadcrumbObject = recursive(menus);
  return breadcrumbObject;
}

export const findOpenKeys = (list, value) => {
  const result = [];

  const find = (arr, val) => {
    const curItem = list.find((v) => v.code === val);
    const {parentCode} = curItem;
    if (parentCode !== '-1') {
      result.unshift(parentCode);
      find(arr, parentCode);
    }
  };

  if (list.length > 0 && value) {
    find(list, value);
  }

  return result;
};
